<nz-layout class="page boxed">
    <nz-content>
        <div class="main-container">
            <nz-spin [nzSpinning]="loading$ | async"><ng-container *ngIf="!prescription; else mainTpl">
                </ng-container></nz-spin>
        </div>
    </nz-content>
</nz-layout>

<ng-template #mainTpl>
    <h1>
        Prescription
        <span style="float: right; font-size: 14px">
            <button nz-button nzType="primary" nzSize="small" (click)="downloadPdf()" style="margin-right: 12px">
                <i class="fas fa-file-pdf"></i> Download PDF
            </button>
            {{ prescription.createdAt | date : 'MM/dd/yyyy' }}
        </span>
    </h1>
    <div class="info-container">
        <nz-descriptions nzTitle="Prescriber" [nzColumn]="1" class="descriptions">
            <ng-container>
                <nz-descriptions-item nzTitle="Provider Name">
                    {{
                    (prescription.meta?.docFirstName ||
                    createdBy?.firstName) +
                    ' ' +
                    (prescription.meta?.docLastName ||
                    createdBy?.lastName) | titlecase
                    }}
                    {{ createdBy?.credential ? ' ' + createdBy.credential : ' NP' }}
                </nz-descriptions-item>
                <!-- This will be renderd for JJC -->
                <nz-descriptions-item *ngIf="providerLicenseDisplay"
                    nzTitle="Provider License Number">
                    {{ providerLicenseDisplay }}
                </nz-descriptions-item>
                <!-- This will be rendered for CarePortals -->
                <nz-descriptions-item *ngIf="prescription?.meta?.docNPI" nzTitle="Provider NPI">
                    {{ prescription.meta.docNPI }}
                </nz-descriptions-item>
                <nz-descriptions-item nzTitle="Provider Address">
                    {{ providerAddress }}
                </nz-descriptions-item>
                <nz-descriptions-item nzTitle="Provider Phone">
                    {{ prescription.meta?.phone }}
                </nz-descriptions-item>
                <nz-descriptions-item nzTitle="Provider Fax">
                    {{ prescription.meta?.fax }}
                </nz-descriptions-item>
            </ng-container>
        </nz-descriptions>

        <nz-descriptions nzTitle="Patient" [nzColumn]="1" class="descriptions">
            <ng-container *ngIf="customer">
                <nz-descriptions-item nzTitle="Patient Name">{{
                    customer.firstName + ' ' + customer.lastName | titlecase
                    }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="DOB">{{
                    customer.dob
                    }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Phone Number">{{
                    customer.phone
                    }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Address">
                    <ng-container *ngIf="customer.defaultAddress">
                        <ng-container *ngIf="customer.defaultAddress.address1">{{
                            customer.defaultAddress.address1
                            }}</ng-container>
                        <ng-container *ngIf="customer.defaultAddress.address2">,
                            {{ customer.defaultAddress.address2 }}</ng-container>
                        <ng-container *ngIf="customer.defaultAddress.city">, {{ customer.defaultAddress.city
                            }}</ng-container>
                        <ng-container *ngIf="
                                customer.defaultAddress.provinceCode ||
                                customer.defaultAddress.province as province
                            ">, {{ province }}</ng-container>
                        <ng-container *ngIf="customer.defaultAddress.postalCode">,
                            {{
                            customer.defaultAddress.postalCode
                            }}</ng-container>
                        <ng-container *ngIf="
                                customer.defaultAddress.countryCode ||
                                customer.defaultAddress.country as country
                            ">, {{ country }}</ng-container>
                    </ng-container>
                    <ng-container *ngIf="!customer.defaultAddress">No address available</ng-container>
                </nz-descriptions-item>
                <nz-descriptions-item *ngIf="
                        customer.identifiers && customer.identifiers[0]?.hcNum
                    " nzTitle="Health Card Number">
                    {{ customer.identifiers[0].hcNum }}
                </nz-descriptions-item>
            </ng-container>
        </nz-descriptions>
    </div>

    <div class="medication-container">
        <h3>Medication:</h3>

        <div class="drugs-container">
            <nz-table #basicTable [nzData]="prescription?.drugs || []" [nzShowPagination]="false" nzSize="small">
                <thead>
                    <tr>
                        <th>Drugs</th>
                        <th>DIN</th>
                        <th [attr.colspan]="5">Sig</th>
                        <th>Mitte</th>
                        <th>Refills</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let drug of basicTable.data">
                        <td>{{ drug.drugName }}</td>
                        <td>{{ drug.din }}</td>
                        <td [attr.colspan]="5">
                            {{ drug.notes }}
                        </td>
                        <td>{{ drug.mitte }}</td>
                        <td>{{ drug.refills }}</td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td [attr.colspan]="9">
                            Notes: {{ prescription.notes }}
                        </td>
                    </tr>
                    <tr *ngFor="let drug of basicTable.data">
                        <td *ngIf="
                                drug.drugName &&
                                (drug.drugName.includes('Cialis') ||
                                    drug.drugName.includes('Viagra') ||
                                    drug.drugName.includes('Cyclen') ||
                                    drug.drugName.includes('Demulen') ||
                                    drug.drugName.includes('Linessa') ||
                                    drug.drugName.includes('Loestrin') ||
                                    drug.drugName.includes('Micronor') ||
                                    drug.drugName.includes('Minestrin') ||
                                    drug.drugName.includes('Reclipsen'))
                            ">
                            Patient Note: Patient requested brand name drug
                        </td>
                    </tr>
                </tfoot>
            </nz-table>
        </div>

        <ng-container *ngIf="isBelugaRx; else signatureTpl">
            <div style="margin-top: 40px">
                <hr style="border: 1px solid #0074b7; margin-bottom: 10px" />
                <p style="margin: 0; font-size: 14px">
                    <strong>Electronically signed by
                        {{ prescription.meta.docFirstName }}
                        {{ prescription.meta.docLastName }} on
                        {{ prescription.createdAt | date }}</strong>
                </p>
            </div>
        </ng-container>
        <ng-template #signatureTpl>
            <div class="signature-container">
                <p>Signature:</p>
                <img [src]="'assets/signatures/' + createdBy._id + '.png'" />
            </div>
        </ng-template>
    </div>

    <div class="footer-container">
        <p>RX Reference #: {{ prescription._id }}</p>
        <p>Printed by: {{ user.firstName + ' ' + user.lastName }}</p>
        <ng-container *ngIf="
                prescription.organization == 'jackjill_health' ||
                prescription.organization == 'jack_health' ||
                prescription.organization == 'jill_health'
            ">
            <p>Jack & Jill Health</p>
            <p>A Modern Telemedicine Company</p>
        </ng-container>
    </div>
</ng-template>